/* eslint-disable */
import React from "react";
import * as typeformEmbed from "@typeform/embed";

export class IssueTrackingFormContainer extends React.Component {
  constructor(props) {
    super(props);
    this.el = null;
  }
  componentDidMount() {
    if (this.el) {
      typeformEmbed.makeWidget(this.el, "https://alexwilliams261692.typeform.com/to/Agg0D2", {
        hideFooter: true,
        hideHeaders: true
      });
    }
  }
  render() {
    return (
      <div ref={ (el) => this.el = el } style={ { width: "80%", height: "80vh", margin: "0 auto" } } />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/containers/issue-tracking-form-container.jsx